"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Tooltips_1 = require("stremio/common/Tooltips");
var ActionsGroup_less_1 = __importDefault(require("./ActionsGroup.less"));
var ActionsGroup = function (_a) {
    var items = _a.items, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(ActionsGroup_less_1.default['group-container'], className) }, items.map(function (item, index) {
        var _a;
        return (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)(ActionsGroup_less_1.default['icon-container'], item.className, (_a = {}, _a[ActionsGroup_less_1.default['disabled']] = item.disabled, _a)), tabIndex: 0, role: 'button', "aria-label": item.label, "aria-disabled": item.disabled || undefined, onClick: item.disabled ? undefined : item.onClick, onKeyDown: function (event) {
                var _a;
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!item.disabled)
                        (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                }
            } },
            item.label &&
                react_1.default.createElement(Tooltips_1.Tooltip, { label: item.label, position: 'top' }),
            react_1.default.createElement(react_2.default, { name: item.icon, className: ActionsGroup_less_1.default['icon'] })));
    })));
};
exports.default = ActionsGroup;
